<template lang="pug">
div
  iframe.default-iframe(
    v-if="urlAcervo",
    showinfo="0",
    width="100%",
    height="800",
    rel="0",
    :src="urlAcervo",
    frameborder="0",
    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
    allowfullscreen,
    modestbranding="1"
  )
</template>

<script>
import { mapActions } from 'vuex'

export default {

  data () {
    return {
      urlAcervo: null
    }
  },

  async created () {
    this.urlAcervo = await this.getArcGis()
  },

  methods: {
    ...mapActions({
      getArcGis: 'arcgis/getUrlAcervoFundiario'
    })
  }
}

</script>
<style lang="scss" scoped>
@import '~@/assets/styles/_variables.scss';

.title {
  color: $color-primary;
}

.main {
  color: $font-color;
  text-align: left;
  padding: 0 10% 0 10%;
  margin-bottom: 20px;
}

iframe {
  border-radius: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/AcervoFundiario.vue